var render = function render(_c,_vm){return _c('div',_vm._g({staticClass:"lz-box",class:[ _vm.props.tight && 'lz-box--tight', _vm.data.staticClass ]},_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }